module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.renderable) ? _c('section', {
    staticClass: "section section-white view-warp el-row"
  }, [_c('div', {
    staticClass: "template-view el-col el-col-24"
  }, [_c('div', {
    staticClass: "template"
  }, [_c('div', {
    staticClass: "components-wrap"
  }, [_c('footers', {
    attrs: {
      "info": _vm.info
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "setting-view el-col el-col-24"
  }, [_c('footer-style', {
    attrs: {
      "info": _vm.info
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "content-padded-s section-white content-center"
  }, [_c('el-button', {
    staticClass: "btn-save",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveConfig
    }
  }, [_vm._v("保存")])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4e59e616", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e59e616"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pc/footerPage/default.vue
// module id = 2698
// module chunks = 0